import React from 'react';
import Utilities from '@util/Utilities';
import HotelRoomMappingType from '@app/model/market_state/HotelRoomMappingType';
import FormButton from '@app/component/form/button/FormButton';
import SecuredFragment from '@app/component/security/SecuredFragment';
import ACLAuthority from '@app/model/profile/ACLAuthority';
import Authority from '@app/model/authentication/Authority';
import MarketStateFilterInput from '@app/model/market_state/input/MarketStateFilterInput';
import { useSelectedCompanyHotel } from '@app/site/secured/rateshopper/rates/provider/useSelectedCompanyHotel';
import MenuButtonFilter from '@app/component/menu/MenuButtonFilter';
import {
	useMarketStateFilterInputTools
} from '@app/site/secured/rateshopper/rates/provider/useMarketStateFilterInputTools';
import CompanyHotelDashboardFilter from '@app/model/company_hotel/settings/CompanyHotelDashboardFilter';

type DashboardSelectRoomTypesFilterProps = {
	filter: MarketStateFilterInput,
	onFilter: (filter: MarketStateFilterInput) => void
}

const DashboardSelectRoomTypesFilter = React.memo(
	function DashboardSelectRoomTypesFilter({ filter, onFilter }: DashboardSelectRoomTypesFilterProps) {
		const {isDashboardFilterEnabled} = useMarketStateFilterInputTools()
		const providerSupportsFilter = isDashboardFilterEnabled(CompanyHotelDashboardFilter.ROOM);

		const { companyHotel } = useSelectedCompanyHotel();
		const menuItems = companyHotel.orderedRoomMappingTypeConfigurations()!
			.filter(c => c.isEnabled && c.type !== HotelRoomMappingType.NONE)
			.map(c => {
				return {
					name: Utilities.snakeCaseToWords(c.name), value: c.type,
				};
			});

		return <MenuButtonFilter
			menuItems={menuItems}
			enableMultiSelect={true}
			selectedValues={filter.roomTypes}
			onMultiSelect={(values) => onFilter({ ...filter, roomTypes: values })}
			multiSelectDisplayText={(selected) =>
				selected.length === 0 ? 'Any Room Type' :
					selected.length > 1 ? `${selected.length} Room Types` :
						selected[0].name
			}
			menuDescription="Please select the room type(s) you wish to include in your results."
			disabled={!providerSupportsFilter}
			footer={
				<SecuredFragment hasAnyAuthority={[Authority.ADMIN, Authority.USER]} hasAclAuthority={ACLAuthority.WRITE}>
					<FormButton state="primary" isLink to="/secured/rateshopper/rates/settings/room-mapping" extraClassName="py-1.5 w-full">
						Edit Room Types
					</FormButton>
				</SecuredFragment>
			}
		/>;
	},
);

export default DashboardSelectRoomTypesFilter;